import actions from '../../actionTypes';

export default user => {
  return {
    type: actions.SET_SITE_USER,
    user
  };
};


// WEBPACK FOOTER //
// ./src/reducers/sites/actions/setSiteUser.js